<template>
  <span class="badge" :class="badgeClass">
    {{ statusLabel }}
  </span>
</template>

<script>
export default {
  name: 'ConversationStatusBadge',
  props: {
    status: {
      type: String,
      required: true,
      validator: value => ['active', 'taken_over', 'closed', 'converted'].includes(value),
    },
  },
  computed: {
    badgeClass() {
      const statusClasses = {
        active: 'badge-info',
        taken_over: 'badge-warning purple',
        closed: 'badge-secondary',
        converted: 'badge-success',
      };
      return statusClasses[this.status] || 'badge-secondary';
    },
    statusLabel() {
      const labels = {
        active: 'Active',
        taken_over: 'Taken Over',
        closed: 'Closed',
        converted: 'Converted',
      };
      return labels[this.status] || this.status;
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 8px;
}

.purple{
  background-color: #9039B6;
  color: white;
}
</style>
